import React, { useState } from 'react';
import { graphql } from 'gatsby';
import { PrismicRichText } from '@prismicio/react';
import css from './FaqSection.module.scss';
import { m } from 'framer-motion';

const FaqItem = ({ data }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={css.FAQquestion}>
      <dt>
        <button className={css.FAQquestionTitleContainer} onClick={() => setOpen(!open)}>
          <span aria-hidden={true} className={css.openClose}>
            {open ? '-' : '+'}
          </span>
          <h3>{data.question}</h3>
        </button>
      </dt>

      <m.dd
        initial="collapsed"
        animate={open ? 'open' : 'collapsed'}
        variants={{
          open: { opacity: 1, height: 'auto', visibility: 'visible', marginTop: '24px' },
          collapsed: { opacity: 0, height: 0, visibility: 'hidden', marginTop: 0 },
        }}
        transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
      >
        <div className={css.answer}>
          <PrismicRichText field={data.answer.richText || data.answer} />
        </div>
      </m.dd>
    </div>
  );
};
const FaqSection = ({ slice }) => {
  return (
    <div id="faq" className={css.wrapper}>
      <div className={css.faqContainer}>
        <h2 className={css.eyebrow}>{slice?.primary?.heading || 'Frequently Asked Questions'}</h2>
        <dl>
          {slice.items.map((item, idx) => {
            return <FaqItem key={idx} data={item} />;
          })}
        </dl>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FeatureHighlightPageDataBodyFaqSection on PrismicFeatureHighlightPageDataBodyFaqSection {
    items {
      question
      answer {
        richText
      }
    }
  }
  fragment HomepageDataBodyFaqSection on PrismicHomepageDataBodyFaqSection {
    items {
      question
      answer {
        richText
      }
    }
  }
  fragment PricingDataBodyFaqSection on PrismicPricingDataBodyFaqSection {
    primary {
      heading
    }
    items {
      question
      answer {
        richText
      }
    }
  }
  fragment LandingPageDataBodyFaqSection on PrismicLandingPageDataBodyFaqSection {
    primary {
      heading
    }
    items {
      question
      answer {
        richText
      }
    }
  }
`;

export default FaqSection;
